import { get } from './utils';

export async function getResourcesApi() {
  return get(`/admin/resources`);
}
